import React from 'react'
import { useTranslation } from 'react-i18next'
import { Clock, Flame } from 'lucide-react'
import useCountdown from '../hooks/useCountdown'
import { formatClockTimer } from '../utils/rushdropFormat'

/**
 * Таймер эвента Rush Drop. Смысл зависит от state:
 * soon — до старта, active/ending — до конца, finished — до закрытия результатов.
 * В ending таймер подсвечивается красным.
 * Варианты: bar — компактная плашка (родитель оборачивает в sticky-контейнер),
 * block — крупный блок (таймер старта вместо списка заданий до начала эвента).
 */
const RushDropTimer = ({ seconds, state, variant = 'bar' }) => {
  const { t } = useTranslation()
  const remaining = useCountdown(seconds)
  const isEnding = state === 'ending'

  const label = state === 'soon'
    ? t('rushdrop.timer.startsIn', 'Старт через')
    : state === 'finished'
      ? t('rushdrop.timer.resultsClose', 'Итоги скроются через')
      : t('rushdrop.timer.endsIn', 'До конца эвента')

  if (variant === 'block') {
    return (
      <div className="flex flex-col items-center gap-2 rounded-2xl border border-white/10 bg-surface px-4 py-8">
        <span className="flex items-center gap-2 text-sm text-text-secondary">
          <Clock size={16} className="text-accent-primary" />
          {label}
        </span>
        <span className="text-5xl font-black tabular-nums text-accent-primary">
          {formatClockTimer(remaining)}
        </span>
      </div>
    )
  }

  return (
    <div
      className={`flex items-center justify-center gap-2 rounded-xl border px-4 py-2.5 backdrop-blur-md ${
        isEnding
          ? 'border-red-500/40 bg-red-500/10'
          : 'border-white/10 bg-surface/90'
      }`}
    >
      {isEnding ? (
        <Flame size={16} className="shrink-0 text-red-400" />
      ) : (
        <Clock size={16} className="shrink-0 text-accent-primary" />
      )}
      <span className={`text-xs ${isEnding ? 'text-red-300' : 'text-text-secondary'}`}>
        {label}
      </span>
      <span className={`text-base font-bold tabular-nums ${isEnding ? 'text-red-400' : 'text-white'}`}>
        {formatClockTimer(remaining)}
      </span>
    </div>
  )
}

export default RushDropTimer
